// extracted by mini-css-extract-plugin
module.exports = {"description":"service-contacts_description__0lhn3"};